module.exports = __webpack_public_path__ + "img/small-paper.90595905.png";